<template>
	<sf-modal-layout size="xl" :title="title" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<part-popup-comm-search ref="partPopupCommSearch" :scrId="scrId" :partNo="this.partNo" />
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="pb-3 border-0 bg-transparent h-100">
					<part-popup-comm-table ref="partPopupCommTable" @close="close" @reload="reload" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';

import partPopupCommSearch from '@qms/pqy/pcku/PartCku/Content/Popup/Search/PartPopupCommSearch.vue';
import partPopupCommTable from '@qms/pqy/pcku/PartCku/Content/Popup/Table/PartPopupCommTable.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { partPopupCommSearch, partPopupCommTable },
	data() {
		return {
			show: false,
			title: '부품검사 항목 공통코드 조회',
			partNo: ''
		};
	},
	created() {
		// console.clear();
		//들어오자마자 state 초기화 하는 방법
		this.setSearchPopupCommInit_();
		// this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.show = true;
			this.partNo = param;
			//console.log('open param ::', param);
			//console.log('this.propPartNo ::', this.partNo);
			if (this.$refs.partPopupCommSearch != undefined) {
				this.$refs.partPopupCommSearch.resetParam(param);
				this.$refs.partPopupCommSearch.searchList(param);
			}
		},
		close() {
			this.$refs.partPopupCommSearch.resetParam();
			this.show = false;
		},
		reload() {
			this.$refs.partPopupCommSearch.searchList();
		}
	}
};
</script>

<style></style>
